<template>
  <div class='body-box marginBox2'>
    <el-row class='plan'></el-row>

    <el-form
      ref='editFormRef'
      :model='editForm'
      label-width='140px'
      style='padding: 20px;background-color: #fff;margin-top: 10px;'
    >
      <el-row>
        <!--球场名称-->
        <el-col :span='8'>
          <el-form-item label='球场名称:'>
            <span>{{ editForm.title }}</span>
          </el-form-item>
        </el-col>

        <!--酒店名称-->
        <el-col :span='8'>
          <el-form-item label='酒店名称:'>
            <!--            <el-input v-model='editForm.hotel' />-->
            <el-select v-model='editForm.hotel' placeholder='请选择'>
              <el-option
                v-for='item in hotelInfo'
                :key='item.id'
                :label='item.hotel'
                :value='item.hotel'>
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <!--入住时间-->
        <el-col :span='8'>
          <el-form-item label='入住时间:'>
            <el-date-picker style='width: 100%;' v-model='editForm.enterDate' type='date'
                            value-format='timestamp'></el-date-picker>
          </el-form-item>
        </el-col>

        <!--离店时间-->
        <el-col :span='8'>
          <el-form-item label='离店时间:'>
            <el-date-picker style='width: 100%;' v-model='editForm.outDate' type='date'
                            value-format='timestamp'></el-date-picker>
          </el-form-item>
        </el-col>

        <!--接送车需要-->
        <el-col :span='8'>
          <el-form-item label='接送车需要:'>
            <el-select v-model='editForm.enumShuttle' clearable placeholder='请选择接送车需要' style='width: 100%'>
              <el-option key='YES' label='是' value='YES'></el-option>
              <el-option key='NO' label='否' value='NO'></el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <!--预约人-->
        <el-col :span='8'>
          <el-form-item label='预约人:'>
            <el-input v-model='editForm.userName' />
          </el-form-item>
        </el-col>

        <!--预约人电话-->
        <el-col :span='8'>
          <el-form-item label='预约人电话:'>
            <el-input v-model='editForm.tel' />
          </el-form-item>
        </el-col>

        <!--预约人邮箱-->
        <el-col :span='8'>
          <el-form-item label='预约人邮箱:'>
            <el-input v-model='editForm.email' />
          </el-form-item>
        </el-col>

        <!--送迎车备注-->
        <el-col :span='8'>
          <el-form-item label='送迎车备注:'>
            <el-input v-model='editForm.distance' />
          </el-form-item>
        </el-col>

        <!--总金额-->
        <el-col :span='8'>
          <el-form-item label='总金额:'>
            <el-input v-model='editForm.cost' />
          </el-form-item>
        </el-col>

        <!--部屋-->
        <el-col :span='8'>
          <el-form-item label='部屋'>
            <el-input v-model='editForm.singleNum' />
          </el-form-item>
        </el-col>

        <!--备注-->
        <el-col :span='24'>
          <el-form-item label='备注:'>
            <el-input type='textarea' v-model='editForm.brief' />
          </el-form-item>
        </el-col>

        <!--用户修改时间-->
        <el-col :span='24' style='padding: 20px 28px;font-size: 16px'>
          <span>打球时间列表:</span>
        </el-col>
        <el-col :span='24'>
          <el-row v-for='(item,index) in dataList' :key='item.key' style='margin-left: 138px;margin-top: 15px'>
            <el-col :span='6'>
              <el-date-picker
                v-model='item.date'
                type='date'
                placeholder='选择日期'>
              </el-date-picker>
            </el-col>
            <el-col :span='6'>
              <el-form-item label='打球时间起'>
                <el-time-select
                  value-format='HH:mm'
                  v-model='item.startTime'
                  placeholder='选择时间'>
                </el-time-select>
              </el-form-item>
            </el-col>

            <el-col :span='6'>
              <el-form-item label='打球时间至'>
                <el-time-select
                  value-format='HH:mm'
                  v-model='item.endTime'
                  placeholder='选择时间'>
                </el-time-select>
              </el-form-item>
            </el-col>
            <span class='el-icon-remove-outline'
                  style='font-size: 20px;cursor: pointer;margin-left: 5px'
                  @click='deleteCourtTime(index)'></span>
            <span class='el-icon-circle-plus-outline'
                  style='margin-left: 10px;font-size: 20px;cursor: pointer;'
                  @click='addCourtTime(index,item.key)' v-if='(dataList.length-1)===index'></span>
          </el-row>
        </el-col>

        <!--修改打球人-->
        <el-col :span='24' style='padding: 20px 58px;font-size: 16px'>
          <span>打球列表:</span>
          <el-button style='margin-left: 10px' size='small' round @click='dialogVisible=true'>添加打球人</el-button>
        </el-col>
        <el-col :span='24' v-for='(item,index) in editForm.groupPerson' :key='item.type'>
          <el-row>
            <el-col style='margin-left: 136px;'>
              <el-select v-for='u in item.data' :key='u.id' v-model='u.name' placeholder='请选择打球人'
                         style='margin-right: 50px;margin-top: 15px'>
                <el-option
                  v-for='item in contactPersons'
                  :key='item.id'
                  :label='item.name'
                  :value='item.id'>
                </el-option>
              </el-select>
              <span class='el-icon-remove-outline'
                    style='font-size: 20px;cursor: pointer;margin-left: 5px'
                    @click='deleteContactPersons(index)'></span>
              <span class='el-icon-circle-plus-outline'
                    style='margin-left: 10px;font-size: 20px;cursor: pointer;'
                    @click='addContactPersons(index,item.type)' v-if='(editForm.groupPerson.length-1)===index'></span>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </el-form>
    <!--添加打球人-->
    <el-dialog
      title='添加打球人'
      :visible.sync='dialogVisible'
      width='30%'>
      <el-input v-model='name' placeholder='请输入打球人姓名' style='width: 30%'></el-input>
      <span slot='footer' class='dialog-footer'>
            <el-button @click='dialogVisible = false' size='small' round>取 消</el-button>
            <el-button type='primary' @click='addGroupPerson' size='small' round>确 定</el-button>
          </span>
    </el-dialog>

    <div class="goBackBox">
      <el-button @click='submitModifyOrder'>修改订单</el-button>
      <el-button @click='goBack'>返回</el-button>
    </div>
  </div>
</template>

<script>
import { modifyOrderTravelsById } from '@/api/order/order'
import { addContactPersons, getContactPersonsByUserId } from '@/api/contactPersons/contactPersons'
import { getData } from '@/utils/code'
import { checkArrayRepeat, getId } from '@/utils/utils'

export default {
  name: 'modifyTravelOrder',
  data() {
    return {
      editForm: {},
      groupPerson: [],
      orderId: '',
      newContent: {},
      newGroupPerson: [],
      courtTime: [],
      newCourtTime: [],
      dialogVisible: false,
      contactPersons: [],
      name: '',
      dataList: [],
      hotelInfo: []
    }
  },

  created() {
    this.orderId = this.$route.query.id
    this.initialize()
  },

  methods: {
    //初始化
    initialize() {
      let data = localStorage.getItem(this.orderId)
      if (data) {
        this.editForm = JSON.parse(data)
        const dataList = JSON.parse(JSON.stringify(this.editForm.courtTime))
        dataList.forEach(f => {
          f.startTime = f.concreteTime.split(' - ')[0]
          f.endTime = f.concreteTime.split(' - ')[1] ? f.concreteTime.split(' - ')[1] : ''
        })
        this.dataList = dataList
        this.hotelInfo = JSON.parse(this.editForm.hotelInfo)
        this.getContactPersons(this.editForm.userId)
      } else {
        this.$message.info('获取订单数据失败!')
      }
    },
    //获取打球人
    getContactPersons(userId) {
      getContactPersonsByUserId(userId).then((res) => {
        this.contactPersons = getData(res) ? getData(res) : []
      })
    },
    //返回
    goBack() {
      this.$router.go(-1)
      localStorage.removeItem(this.orderId)
    },

    replace() {
      this.courtTime = this.newCourtTime
    },

    replacePeople() {
      this.groupPerson = this.newGroupPerson
    },

    submitModifyOrder() {
      let personNum = 0
      let gp = []
      if (this.editForm.groupPerson.length > 0) {
        gp = JSON.parse(JSON.stringify(this.editForm.groupPerson))
        gp.forEach((item, i) => {
          item.data.forEach((data, index) => {
            if (data.name) {
              personNum += 1
            } else {
              gp[i].data.splice(index, 4)
            }
          })
          if (item.data.length === 0) {
            gp.splice(i, 1)
          }
        })
      }
      // 验证名字是否有重复
      let check = checkArrayRepeat(this.editForm.groupPerson, personNum)
      if (!check) {
        this.$message.info('不能有相同的打球人!')
        return
      }
      let arr = []
      this.dataList.forEach((f, i) => {
        const obj = {
          concreteTime: f.endTime ? `${f.startTime} - ${f.endTime}` : f.startTime,
          key: i + 1,
          date: f.date
        }
        arr.push(obj)
      })
      const data = {
        cost: this.editForm.cost,
        courtTime: JSON.stringify(arr),
        email: this.editForm.email,
        enterDate: this.editForm.enterDate,
        enumShuttle: this.editForm.enumShuttle,
        groupPerson: JSON.stringify(gp),
        hotel: this.editForm.hotel,
        outDate: this.editForm.outDate,
        personNum: personNum,
        singleNum: this.editForm.singleNum,
        tel: this.editForm.tel,
        userName: this.editForm.userName,
        brief: this.editForm.brief,
        distance: this.editForm.distance
      }

      modifyOrderTravelsById(data, this.orderId).then(res => {
        if (res.code === '0') {
          this.$message.success('执行成功!')
          localStorage.removeItem(this.orderId)
          this.goBack()
        }
      })
    },
    //删除一组
    deleteContactPersons(index) {
      if ((this.editForm.groupPerson.length - 1) === 0) {
        this.$message.info('至少留一组!')
        return
      }
      this.editForm.groupPerson.splice(index, 1)
    },
    //添加打球人
    addGroupPerson() {
      if (this.name === '') {
        this.$message.info('请输入打球人姓名!')
        return
      }
      let data = {
        name: this.name,
        userId: this.editForm.userId
      }
      addContactPersons(data).then((res) => {
        let data = getData(res)
        if (data !== null) {
          this.$message.success('添加成功')
          this.name = ''
          this.getContactPersons(this.editForm.userId)
          this.dialogVisible = false
        }
      })
    },
    addContactPersons(index, type) {
      let d = {
        type: parseInt(type) + 1,
        data: [
          {
            id: getId(10)
          },
          {
            id: getId(10)
          },
          {
            id: getId(10)
          },
          {
            id: getId(10)
          }
        ]
      }
      this.editForm.groupPerson.push(d)
    },
    //删除打球时间
    deleteCourtTime(index) {
      if (this.dataList.length - 1 < 2) {
        this.$message.info('至少留2组打球时间')
        return
      }
      this.dataList.splice(index, 1)
    },
    //添加打球时间
    addCourtTime(index, key) {
      let time = {
        concreteTime: '',
        key: key + 1,
        date: ''
      }
      this.dataList.push(time)
    }

  }
}
</script>

<style lang='less' scoped>

</style>
